import { Injectable, inject } from '@angular/core';

import { ExtStatsActionQueryI } from 'src/app/api/stats-action/stats-action.query.ext';
import { ExtStatsConnectQueryI } from 'src/app/api/stats-connect/stats-connect.query.ext';
import { ExtStatsUpdateLogQueryI } from 'src/app/api/stats-update-log/stats-update-log.query.ext';
import { ExtStatsVersionCheckQueryI } from 'src/app/api/stats-version-check/stats-version-check.query.ext';
import { HttpClient } from '@angular/common/http';
import { MapStatsAction } from 'src/app/api/stats-action/stats-action.map';
import { MapStatsConnect } from 'src/app/api/stats-connect/stats-connect.map';
import { MapStatsUpdateLog } from 'src/app/api/stats-update-log/stats-update-log.map';
import { MapStatsVersionCheck } from 'src/app/api/stats-version-check/stats-version-check.map';
import { StatsActionQueryI } from 'src/app/api/stats-action/stats-action.query.int';
import { StatsConnectQueryI } from 'src/app/api/stats-connect/stats-connect.query.int';
import { StatsUpdateLogQueryI } from 'src/app/api/stats-update-log/stats-update-log.query.int';
import { StatsVersionCheckQueryI } from 'src/app/api/stats-version-check/stats-version-check.query.int';
import { catchError } from 'rxjs/operators';
import { statsApiEndpoints } from '../_config/stats-api-endpoints.const';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private readonly httpClient = inject(HttpClient);

  action(unmappedQuery: StatsActionQueryI) {
    const query: ExtStatsActionQueryI = MapStatsAction.mapQuery(unmappedQuery);
    const actionData = query.request.actionData
      ? `&actionData=${encodeURIComponent(JSON.stringify(query.request.actionData))}`
      : '';

    return this.httpClient.get(`${statsApiEndpoints.action}?app=${encodeURIComponent(query.request.app)}&customer=${encodeURIComponent(query.request.customer.replace('/','-'))}&action=${encodeURIComponent(query.request.action)}&randomDeviceId=${encodeURIComponent(query.request.randomDeviceId)}&username=${encodeURIComponent(query.request.username)}${actionData}`).pipe(
      catchError(() => {
        return throwError(() => 'Couldn\'t log action');
      })
    )
  }

  connect(unmappedQuery: StatsConnectQueryI) {
    const query: ExtStatsConnectQueryI = MapStatsConnect.mapQuery(unmappedQuery);
    return this.httpClient.get(`${statsApiEndpoints.connect}?app=${encodeURIComponent(query.request.app)}&customer=${encodeURIComponent(query.request.customer.replace('/','-'))}&username=${encodeURIComponent(query.request.username)}&randomDeviceId=${encodeURIComponent(query.request.randomDeviceId)}&patch=${encodeURIComponent(query.request.patch)}&release=${encodeURIComponent(query.request.release)}&bundleVersion=${encodeURIComponent(query.request.bundleVersion)}&liveUpdate=${encodeURIComponent(query.request.liveUpdate)}&liveUpdateChannel=${encodeURIComponent(query.request.liveUpdateChannel)}&platform=${encodeURIComponent(query.request.platform)}&platformVersion=${encodeURIComponent(query.request.platformVersion)}&frontEndVersion=${encodeURIComponent(query.request.frontEndVersion)}`).pipe(
      catchError((error) => {
        return throwError(() => 'Couldn\'t log stats');
      })
    )
  }

  versionCheck(unmappedQuery: StatsVersionCheckQueryI) {
    const query: ExtStatsVersionCheckQueryI = MapStatsVersionCheck.mapQuery(unmappedQuery);
    return this.httpClient.get(`${statsApiEndpoints.versionCheck}?app=${encodeURIComponent(query.request.app)}&bundleVersion=${encodeURIComponent(query.request.bundleVersion)}`).pipe(
      catchError((error) => {
        return throwError(() => 'Couldn\'t log action');
      })
    )
  }

  updateLog(unmappedQuery: StatsUpdateLogQueryI) {
    const query: ExtStatsUpdateLogQueryI = MapStatsUpdateLog.mapQuery(unmappedQuery);
    return this.httpClient.get(
      `${statsApiEndpoints.updateLog}?` +
      `app=${encodeURIComponent(query.request.app)}` +
      `&step=${encodeURIComponent(query.request.step)}` +
      `&status=${encodeURIComponent(query.request.status)}` +
      `&customer=${encodeURIComponent(query.request.customer.replace('/', '-'))}` +
      `&channelType=${encodeURIComponent(query.request.channelType)}` +
      `&liveUpdateChannel=${encodeURIComponent(query.request.liveUpdateChannel)}` +
      `&username=${encodeURIComponent(query.request.username)}` +
      `&randomDeviceId=${encodeURIComponent(query.request.randomDeviceId)}` +
      `&updateCheckType=${encodeURIComponent(query.request.updateCheckType)}` +
      `&platform=${encodeURIComponent(query.request.platform)}` +
      `&platformVersion=${encodeURIComponent(query.request.platformVersion)}` +
      `&bundleVersion=${encodeURIComponent(query.request.bundleVersion)}` +
      `&liveUpdate=${encodeURIComponent(query.request.liveUpdate)}` +
      `&eventAt=${encodeURIComponent(query.request.eventAt)}` +
      `&details=${encodeURIComponent(query.request.details)}` +
      `&error=${encodeURIComponent(query.request.error)}` +
      `&steps=${encodeURIComponent(query.request.steps)}` +
      `&frontEndVersion=${encodeURIComponent(query.request.frontEndVersion)}`
    ).pipe(
      catchError(() => {
        return throwError(() => 'Couldn\'t log update actions');
      })
    )
  }

}
